"use server";
/**
 * Poarta paletei de comenzi spre server — o singură acțiune de registru.
 *
 * Nu revalidează nimic (`revalidate: false`): e o citire, iar o revalidare a celor ~30 de
 * suprafețe la fiecare tastare ar fi golit cache-ul întregii aplicații de zeci de ori pe minut.
 */
import { ui, type ActionResult } from "@/lib/actions/ui";
import type { PaletteHit } from "@/lib/actions/catalog/palette";

export async function cautaGlobal(query: string): Promise<ActionResult<PaletteHit[]>> {
  return ui<PaletteHit[]>("search.global", { query }, { revalidate: false });
}
